/**
 * The panel itself: in light mode the page is a white panel on the gray background, as the Retool
 * apps are, and `--background` is the card colour inside it so the table's sticky header and
 * pinned columns match the panel. In dark mode the page has no panel.
 */
const PANEL =
  "rounded-lg bg-card p-4 [--background:var(--card)] dark:rounded-none dark:bg-transparent dark:p-0 dark:[--background:inherit]";

/**
 * The root classes of a fulfillment page that replaces a Retool app inside the dashboard's own
 * column (Packing): the panel reaches half way into the column's `p-8`, so it stays inset.
 */
export const FULFILLMENT_PANEL_CLASS = `-m-4 dark:m-0 ${PANEL}`;

/**
 * The same panel on a page at Retool's width (`staticData.pageWidth`: the order list and one
 * order), whose column has only a `p-4` gutter: no negative margin, so the gray still shows round it.
 */
export const FULFILLMENT_WIDE_PANEL_CLASS = PANEL;
